module.exports = __webpack_public_path__ + "img/fogyfel.4290f6da.svg";